import React from 'react'
import Headertwo from '../headertwo/Main'
import Headerone from "../headerone/Main"
import Slider from "../menhome/Sliderone";
import Child from '../menhometwo/Child'
import Service from '../menhometwo/Service'
import Aboutkids from '../menhometwo/Aboutkids'
import Goging from '../menhometwo/Goging'
import Aboutvideo from '../menhometwo/Aboutvideo'
import Events from '../menhometwo/Events'
import Teacher from '../menhometwo/Teacher'
import Testimonial from '../menhometwo/Testimonial'
import Blog from '../menhometwo/Blog'
import Blueslider from '../menhometwo/Blueslider'
import CourseCard from '../menhome/CourseCard'
import Two from '../Pages/menevent/Two'
import Frequently from '../menhome/Frequently'

function Main() {
  return (
   <>
        <Headerone/>
        <Slider/>
        <Child/>
        <Service/>
        <Aboutkids/>
        {/* <Goging/> */}
        <Aboutvideo/>
        <CourseCard />
        {/* <Events/> */}
        {/* <Teacher/> */}
        <Testimonial/>
        {/* <Blog/> */}
        <Two/>
        <Frequently />
        {/* <Blueslider/> */}
   </>
  )
}

export default Main